export default class BaseService {
  constructor(self) {
    this._self = self;
  }

  validaToken() {
    //Verifica se o Access Token é válido
    var keyToken = "msal." + this._self.$Configs.AzureAd.ClientId + ".idtoken";
    if (sessionStorage[keyToken]) {
      var tokenSplited = sessionStorage[keyToken].split('.');
      if (tokenSplited.length == 3) {
        let objToken = JSON.parse(atob(tokenSplited[1]));

        //Se token for válido, retorna
        if (Date.now() < objToken.exp * 1000)
          return Promise.resolve({
            accessToken: sessionStorage[keyToken]
          });
      }
    }

    //Caso token for inválido, busca um novo
    let tokenRequest = {
      scopes: [this._self.$Configs.AzureAd.ClientId + '/.default']
    }

    return this._self.$msal.acquireToken(tokenRequest).then(
      retorno => {
        sessionStorage.setItem(keyToken, retorno.accessToken);
        return Promise.resolve({
          accessToken: retorno.accessToken
        });
      })
      .catch(erro => {
        Promise.reject({
          msg: "Não foi possível obter o access token" + erro
        })
      });
  }

  ExecutaFetch(url, method, parameters) {
    //executa a verificação de token
    var x = this.validaToken();
    return x.then(response => {

      var headers = new Headers();
      var bearerToken = "Bearer " + response.accessToken;

      headers.append("Authorization", bearerToken);
      headers.append("Content-Type", "application/json");
      var options = {
        method: method,
        headers: headers
      };

      if (method == "POST") {
        options.body = JSON.stringify(parameters);
      }

      return fetch(url, options)
        .catch(error => {
          error.body = {
            status: 0,
            Mensagem: "Falha na conexão. Por favor, verifique se há conexão com a internet."
          };
          throw error;
        }) // handle network issues
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          }

          if (response.status == 401 || response.status == 403) {
            let msg = "";
            switch (response.status) {
              case 401: msg = "Você não está autenticado."; break;
              case 403: msg = "Você não está autorizado para executar essa ação."; break;
            }
            return response.text().then(text => {
              return Promise.reject({
                status: response.status,
                ok: false,
                statusText: response.statusText + " | " + text,
                body: { Mensagem: msg }
              });
            });
          }

          return response.json().then(json => {
            return Promise.reject({
              status: response.status,
              ok: false,
              statusText: response.statusText,
              body: json
            });
          });
        })
        .then(response => {
          if (response.status === 204 || response.status === 205) {
            return null;
          }

          return response.json();
        })
        .catch(error => {
          throw error;
        });

    }).catch(error => {
      throw error;
    });
  }
}